import { motion } from "framer-motion";
import { Flame } from "lucide-react";
import { useT } from "@/i18n";

export const StreakFlame = ({ streak }) => {
  const { t } = useT();
  if (!streak) return null;
  const n = streak.current || 0;
  const intensity = Math.min(n, 10);

  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.9, y: -8 }}
      animate={{ opacity: 1, scale: 1, y: 0 }}
      transition={{ type: "spring", stiffness: 300, damping: 20 }}
      className="flex items-center gap-3 rounded-2xl border border-[#FF8A3D]/30 bg-gradient-to-r from-[#FF8A3D]/10 to-[#D4AF37]/10 px-5 py-4"
      data-testid="streak-flame"
    >
      <div className="relative flex h-11 w-11 items-center justify-center">
        <motion.div
          className="absolute inset-0 rounded-full blur-lg"
          style={{ background: "radial-gradient(circle, rgba(255,138,61,0.7), transparent 70%)" }}
          animate={{ scale: [1, 1.25, 1], opacity: [0.6, 1, 0.6] }}
          transition={{ duration: 1.2, repeat: Infinity }}
        />
        <motion.div
          animate={{ scale: [1, 1.12, 1], rotate: [-4, 4, -4] }}
          transition={{ duration: 0.9, repeat: Infinity, ease: "easeInOut" }}
        >
          <Flame className="relative h-7 w-7 fill-[#FF8A3D] text-[#FFD27D]" />
        </motion.div>
      </div>
      <div>
        <p className="font-serif text-xl font-semibold text-[#FFD27D]" data-testid="streak-count">
          {n <= 1 ? t("streak.first") : t("streak.days", { n })}
        </p>
        <p className="text-xs text-[#A3B1C6]">{n <= 1 ? "✨" : t("streak.keep")}</p>
      </div>
      {n > 1 && (
        <div className="ml-auto flex gap-0.5">
          {Array.from({ length: intensity }).map((_, i) => (
            <motion.span
              key={i}
              className="text-sm"
              animate={{ y: [0, -3, 0], opacity: [0.5, 1, 0.5] }}
              transition={{ duration: 0.8, repeat: Infinity, delay: i * 0.08 }}
            >
              🔥
            </motion.span>
          ))}
        </div>
      )}
    </motion.div>
  );
};
